import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';

/**
 * Public guard - allows access without authentication
 * Used for public routes like resource-view that use access codes
 */
export const PublicGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    console.log('🟢 PublicGuard called for route:', state.url);
    console.log('🟢 Route path:', route.routeConfig?.path);
    console.log('🟢 Full URL:', state.url);
    
    // Always allow access - no authentication required
    return of(true);
};

